import CancerPage from "../components/CancerPage";

const stepsText = [
  "1. Histopathological Analysis: A pathologist will perform a detailed examination of the tissue sample, evaluating: (A) Cellular Morphology, (B) Tissue Architecture, (C) Tumor Invasiveness.",
  "2. Immunohistochemistry (IHC): Special stains are used to: (A) Confirm the Diagnosis, (B) Determine Subtype, (C) Guide Targeted Therapy.",
  "3. Molecular and Genetic Testing: (A) Microsatellite Instability (MSI) testing, (B) RAS and BRAF mutation analysis, (C) Tumor-Mutational Burden (TMB) analysis.",
  "These comprehensive steps, combining microscopic observation with advanced molecular analysis, provide a complete picture of the cancer and guide treatment decisions.",
];

export default function ColonCancerPage() {
  return (
    <CancerPage
      cancerName="Colon Cancer"
      scanType="Microscope images of tissue"
      analysisText="The image shows a microscopic section of colon tissue, specifically highlighting colorectal adenocarcinoma. This type of cancer originates in the glandular cells lining the colon. The areas circled in green illustrate a key feature associated with this malignancy: tumor glands in proximity to adipocytes (fat cells) without direct contact. This observation is significant because it relates to a biomarker called Tumor-Adipose-Feature (TAF), which is identified using deep learning algorithms. The presence of TAF indicates a higher likelihood of a poor prognosis for the patient."
      stepsTitle="Necessary Steps for Pathological Diagnosis:"
      stepsText={stepsText}
    />
  );
}
